import type { Translate } from "../../../shared/i18n";
import type { KeyValueItem } from "../KeyValueList";
import type { TraceRecord } from "./traceApi";

function text(value: unknown): string {
  if (value === null || value === undefined) return "-";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return JSON.stringify(value);
}

/** Message, ids and the free-form extra fields as labeled pairs. */
export function recordDetailItems(
  t: Translate,
  record: TraceRecord,
): KeyValueItem[] {
  const named: KeyValueItem[] = [
    { label: t("admin.logs.field.message"), value: text(record.message) },
    {
      label: t("admin.logs.field.correlation_id"),
      value: text(record.correlation_id),
    },
    { label: t("admin.logs.field.job_id"), value: text(record.job_id) },
    { label: t("admin.logs.field.session_id"), value: text(record.session_id) },
    { label: t("admin.logs.field.turn_id"), value: text(record.turn_id) },
    { label: t("admin.logs.field.user_id"), value: text(record.user_id) },
  ];
  const extra = Object.entries(record.extra).map(([key, value]) => ({
    label: `${t("admin.logs.field.extra")}: ${key}`,
    value: text(value),
  }));
  return [...named, ...extra];
}
